// extracted by mini-css-extract-plugin
export default {"heartButton":"WishListItemToggle_heartButton__xnezy","filled":"WishListItemToggle_filled__3Z9vB","listItem":"WishListItemToggle_listItem__3baeC"};